import * as React from "react";

import { Root } from "./Table2.styles";
import { Table2ColumnPaddingContext } from "./Table2ColumnPaddingContext";

interface Table2Props {
    columnWidths?: Array<number | string>;
    columnPadding?: string;
    children: React.ReactNode[];
}

export function Table2(props: Table2Props): JSX.Element {
    return (
        <Root>
            {props.columnWidths != undefined && (
                <colgroup>
                    {props.columnWidths.map((width, index) => (
                        <col width={width} key={index} />
                    ))}
                </colgroup>
            )}
            <Table2ColumnPaddingContext.Provider value={props.columnPadding}>
                <tbody>{props.children}</tbody>
            </Table2ColumnPaddingContext.Provider>
        </Root>
    );
}
